const testimonials = [
  {
    name: "Priscilla H.",
    location: "Mount Pleasant, SC",
    rating: 5,
    text: "We had a Caribbean cruise leaving from Port of Charleston in 5 days and realized my husband's passport was expired. Fast Passport Center got us a renewal in 4 days. The step-by-step guidance was incredible — truly saved our vacation.",
    service: "Passport Renewal",
  },
  {
    name: "Robert D.",
    location: "Charleston Peninsula, SC",
    rating: 5,
    text: "Business trip to London in 6 days, my passport was set to expire mid-trip. Called at 7 PM and someone answered. Shipped from a FedEx on Rutledge Avenue and had my renewed passport back in 5 days. Unreal service.",
    service: "Emergency Passport",
  },
  {
    name: "Alicia F.",
    location: "Summerville, SC",
    rating: 5,
    text: "My son needed a passport for a school trip to the Bahamas. I was totally lost on the process. Fast Passport Center sent a clear checklist, told us exactly which post office to visit in North Charleston, and handled everything else. Got it in 8 days.",
    service: "Child Passport",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function CharlestonTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Charleston Travelers Say About Our Expedited Passport Service
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from real travelers across Charleston, Mount Pleasant, Summerville, and the Lowcountry who trusted Fast Passport Center with their emergency and expedited passports.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div key={i} className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col">
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">&ldquo;{t.text}&rdquo;</p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">{t.service}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}